"use client";

import { Input } from "@/components/ui/input";
import { type ActiveFilter, type FilterFieldDef } from "./types";

export function FilterTextValue({
  filter,
  field,
  onUpdate,
}: {
  filter: ActiveFilter;
  field: FilterFieldDef;
  onUpdate: (updated: ActiveFilter) => void;
}) {
  return (
    <div className="min-w-[100px] max-w-[200px]">
      <Input
        type="text"
        variant="ghost"
        size="none"
        value={filter.value}
        onChange={(e) => onUpdate({ ...filter, value: e.target.value })}
        placeholder={field.placeholder ?? "Type…"}
        className="h-full w-full px-1.5 text-[13px] font-medium text-contrast/75 placeholder:text-contrast/25"
      />
    </div>
  );
}
